import { Input } from 'taboola-ultimate-ui';
import { useEventValueHandler } from 'hooks';
import { withIndication } from 'modules/errors/components';
import { useFormValidatedValue } from 'modules/taboola-common-frontend-modules/validations';
import styles from './valueCriterionInputField.module.scss';

const InputWithIndication = withIndication(Input, styles['value-field']);

export const ValueCriterionInputField = ({ selectedValueCriterion }) => {
    const {
        value: inputValue,
        onChange: valueOnChange,
        indicationData,
    } = useFormValidatedValue({
        field: selectedValueCriterion,
    });

    const changeHandler = useEventValueHandler(valueOnChange);

    return (
        <div className={styles['input']}>
            <InputWithIndication
                id={`${selectedValueCriterion}-input`}
                onChange={changeHandler}
                value={inputValue}
                inputClass={styles['input-container']}
                aria-label="input-criterion"
                {...indicationData}
            />
        </div>
    );
};
